module.exports = __webpack_public_path__ + "static/media/UVO-Logo-2.7b083971.png";